var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workflow-pending" },
    [
      _c(
        "div",
        { staticClass: "top-navigation" },
        [
          _c("button-group", {
            attrs: {
              items: _vm.pendingTaskFilters,
              label: "Filters",
              uppercase: "",
              value: _vm.filter
            },
            on: {
              change: function($event) {
                return _vm.$emit("filterChanged", $event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("no-results", {
        attrs: {
          "is-loading": _vm.isLoading,
          message: _vm.emptyMessage,
          results: _vm.pendingTaskList
        }
      }),
      _vm._v(" "),
      _vm.pendingTaskList.length
        ? _c(
            "div",
            { staticClass: "pending-task-list" },
            [
              _c("DynamicScroller", {
                attrs: {
                  "key-field": "pendingTaskId",
                  items: _vm.pendingTaskList,
                  "min-item-size": 38
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var item = ref.item
                        var index = ref.index
                        var active = ref.active
                        return [
                          _c(
                            "DynamicScrollerItem",
                            {
                              staticClass: "scroller-item",
                              attrs: {
                                active: active,
                                "data-active": active,
                                "data-index": index,
                                item: item
                              }
                            },
                            [
                              _c("pending-task-list-item", {
                                attrs: { index: index, item: item }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3737804212
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e230b5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e230b5e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-pending/component.vue
// module id = 1690
// module chunks = 0